export default "__VITE_ASSET__8a19ce4c__"